"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconApple = void 0;
var React = __importStar(require("react"));
var IconApple = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M16.5283,11.5726 C16.5523,14.2996 18.9703,15.1996 19.0003,15.2096 C18.9853,15.2726 18.6213,16.5096 17.7143,17.7646 C16.9573,18.8716 16.1633,19.9516 14.9033,19.9716 C13.6783,19.9996 13.2673,19.2676 11.8623,19.2676 C10.4453,19.2676 10.0063,19.9516 8.8323,19.9996 C7.6323,20.0426 6.7153,18.8186 5.9303,17.7226 C4.3613,15.4856 3.1403,11.4186 4.7773,8.6506 C5.5713,7.2936 7.0183,6.4196 8.5643,6.3956 C9.7653,6.3716 10.8813,7.1876 11.6193,7.1876 C12.3443,7.1876 13.7223,6.2116 15.1443,6.3566 C15.7383,6.3736 17.4313,6.5866 18.5233,8.1406 C18.4353,8.1926 16.5073,9.2996 16.5283,11.5726 Z M14.2158,4.886 C13.5568,5.645 12.5018,6.225 11.4748,6.151 C11.3408,5.126 11.8618,4.036 12.4438,3.372 C13.1018,2.617 14.2448,2.04 15.1588,2 C15.2788,3.065 14.8468,4.115 14.2158,4.886 Z" }))); };
exports.IconApple = IconApple;
exports.IconApple.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconApple;
